import { Platform, Share } from 'react-native';
import { apiFile } from './api';

/** "Download my data": saves the file in a browser; on a phone, opens the share sheet with it. */
export async function downloadMyData() {
  const { text, name } = await apiFile('/me/export');
  if (Platform.OS === 'web') {
    const url = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
    return;
  }
  await Share.share({ title: name, message: text });
}
